<template>
  <div class="ranking-box">
    <div class="ranking-title-box">
      <h5 class="common-h5">排行榜</h5>
    </div>
    <el-table :data="tableData" style="width: 100%;">
      <el-table-column prop="userName" width="70px" show-overflow-tooltip label="员工姓名"> </el-table-column>
      <el-table-column prop="phone" width="60px" show-overflow-tooltip label="电话"> </el-table-column>
      <el-table-column prop="departmentName" width="60px" show-overflow-tooltip label="部门"> </el-table-column>
      <el-table-column prop="maintainDateAmount" show-overflow-tooltip width="80px" label="保养日统计"> </el-table-column>
      <el-table-column prop="maintainMonthAmount" show-overflow-tooltip width="80px" label="保养月统计"> </el-table-column>
      <el-table-column prop="repairCommission" show-overflow-tooltip width="110px" label="维修提成月统计"> </el-table-column>
      <el-table-column prop="repairMonthAmount" show-overflow-tooltip width="80px" label="维修月统计"> </el-table-column>

    </el-table>
  </div>
</template>

<script>
import { getUserRankingList } from '@/api/UserConsole'
export default {
  data() {
    return {
      tableData: [
      ],
    };
  },
  created() {
    this.getUserRankingList()
  },
  methods: {
    async getUserRankingList() {
      const params = {
        pageIndex: 1,
        pageSize: 10
      }
      const res = await getUserRankingList(params)
      console.log(res)
      if (res.code===200) {
        this.tableData = res.data
      }
    }
  }
};
</script>

<style lang="scss">
.ranking-box {
  height: 100%;
  .ranking-title-box {
    padding: 14px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/UserConsole/components/Ranking.vue